<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong>{{type}} Email Templates </strong>
      </span>
      <!-- <span style="float: right">
        <strong>Send Password Protected Attachment</strong>:<input type="checkbox"  [(ngModel)]="PasswordProtected"  (change)="ChangeAttacmentStatus()">
      </span> -->
    </div>
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
  
            <div class="table-responsive mb-5">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                class="table table-hover compact cell-border nowrap stripe" id="reminderTable" style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Subject </th>
                    <th class="actionclass">Action</th>
                  </tr>
                </thead>
  
                <tbody>
                  <tr *ngFor="let reminder of reminders;">
                    <td tabindex="1">{{reminder.Title }}</td>
                    <td tabindex="1">{{reminder.Subject }}</td>
                    <td style='white-space: nowrap'>
                      <button type="button" title="Edit"
                        [appHasPermission]="{'Url': environmentService.Compliance ? '/emailReminderTemplates/edit?goveva=true&email=' : '/upsiAdmin/email/edit?goveva=true&email=', 'method':'put', 'menu': environmentService.Compliance ? 'Email Template' : 'Edit Email Template'}"
                        class="btn-sm btn btn-warning" (click)="loadEmailReminderToEdit(reminder._id)">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
  
            <div class="modal fade modal-size-large" id="reminderDialog" tabindex="-1" role="dialog" aria-labelledby=""
              aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="reminderMasterForm" class="well">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="reminderModalLabel">Email Templates</h5>
                      <button aria-label="Close" class="close" (click)="intializeDatatable()" data-dismiss="modal"
                        type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
  
                      <div class="row" [hidden]="!IsUpsiEmail">
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">To
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
                            Select on of them:<span> (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</span>
                            <input class="emailTo" name="emailTo" type="text">
                          </div>
                        </div>
                      </div>
  
                      <div class="row" [hidden]="!IsUpsiEmail">
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">CC
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
                            Select on of them:<span> (Sharer, Recipient, Data entry person, ADMIN, UPSI All data)</span>
                            <input class="emailCC" name="emailCC" type="text">
                          </div>
                        </div>
                      </div>
  
  
                      <div class="row">
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">Title
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
                            <input [formControl]="reminderMasterForm.controls['Title']" class="form-control"
                              placeholder="Email Title">
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">Subject
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
                            <input [formControl]="reminderMasterForm.controls['Subject']" class="form-control"
                              placeholder="Email Subject">
                            <div
                              *ngIf="reminderMasterForm.controls['Subject'].hasError('required') && reminderMasterForm.controls['Subject'].touched"
                              class="form-control-error-custom">
                              Email Subject is required.
                            </div>
                            <div *ngIf="reminderMasterForm.controls['Subject'].hasError('noSpecialCharacters')"
                            class="form-control-error-custom">
                              User Input cannot contain special characters.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" [hidden]="true" >
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">Attachment
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
  
                            <input name="Attachment" class='form-control' type="file" (change)="fileChanged($event)">
                          </div>
                        </div>
                      </div>
  
                      <div class="row" [hidden]="true" >
                        <div class="col-lg-1" *ngIf="DocumentFileDoc">
                          <label class="form-control-label">Document</label>
                        </div>
                        <div class="col-lg-11" *ngIf="DocumentFileDoc">
                          <div class="form-group">
  
                          <a class="btn btn-sm btn-default"><span
                              (click)="downloadFile()">{{FileNameO }}</span>&nbsp;<span (click)="downloadFile()"
                              style="margin-left: 10px"><i class="fa fa-download"></i></span><span
                              (click)="deleteFile()" style="margin-left: 10px"><i class="fa fa-close"
                                style="color: white"></i></span></a>
                            </div>
  
                        </div>
                      </div>
  
                      <div class="row" [hidden]="true">
  
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">Email Text </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
  
                            <textarea [formControl]="reminderMasterForm.controls['EmailText']" class="form-control"
                              rows="3">
                            </textarea>
                          </div>
                        </div>
                      </div>
  
                      <div class="row">
                        <div class="col-md-1">
                          <label class="form-control-label" for="l0">Body
                          </label>
                        </div>
                        <div class="col-md-11">
                          <div class="form-group">
                            <!-- <div  [ngxSummernote]="config"></div>              -->
                            <!-- <div [ngxSummernote]="config"></div> -->
                            <div id="summernote"></div>
                            <!-- <textarea id="summernote" class="form-control"></textarea> -->
                            <!-- <div class="summernote"></div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnupdateReminder" style="display:none;" type="button" class="btn btn-sm btn-primary"
                        [disabled]="!reminderMasterForm.valid || disabledOnclick" (click)="checKkeyWordsAlert()">
                        <i class="fa fa-save"></i>&nbsp;Update
                      </button>
                      <button type="button" class="btn btn-sm" (click)="intializeDatatable()" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
  
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
              style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Error</h5>
                    <button _ngcontent-c1="" aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div id="alertMessage" style="font-size: 16px;">
                      <div class="row">
                        <div class="col-sm-12">
                          <b>Some key words are missing Use below keywords in Tempaltes!</b>
                          <br>
                          <div *ngIf="keywordsMissingBodyAlert">
                            Body : {{missingBodyKeywords}}
                          </div>
                          <div *ngIf="keywordsMissingSubjectAlert">
                            Subject : {{missingSubjectKeywords}}
                          </div>
  
                        </div>
                      </div>
                    </div>
  
                  </div>
                  <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-sm btn-danger" (click)="proceedForUpdate()">
                      <i class="fa fa-check"></i>Yes
                    </button> -->
                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                      <i class="fa fa-times"></i>OK
                    </button>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-alert></app-alert>